<template>
    <div class="card overflow-hidden" :class="{
        'border border-danger': offer.expired,
        'border border-warning': !offer.expired && !offer.articles_count,
    }">
        <div class="card-body">
            <div class="d-flex">
                <div class="flex-grow-1">
                    <div v-if="isSystemGenerated || offer.expired" class="mb-5">
                        <span v-if="isSystemGenerated" class="bg-secondary text-dark px-3 py-1 rounded font-size-sm">
                            {{ __('offers.generated') }}
                        </span>
                        <span v-if="offer.expired" class="bg-danger text-white px-3 py-1 rounded font-size-sm">
                            {{ __('offers.expired') }}
                        </span>
                    </div>
                    <div class="font-size-h2">{{ offer.name }}</div>
                    <div>
                        <table>
                            <tr>
                                <td class="pr-2">{{ __('general.created') }}:</td>
                                <td>
                                    {{ $localDate(offer.created_at) }}
                                </td>
                            </tr>
                            <tr :class="{'text-danger font-weight-bold': offer.expired}">
                                <td class="pr-2">{{ __('general.valid_till') }}:</td>
                                <td>
                                    <span v-if="offer.expired_at">
                                        {{ $localDate(offer.expired_at) }}, {{ $localTime(offer.expired_at) }} Uhr
                                    </span>
                                    <span v-else>{{ __('general.unlimited') }}</span>
                                </td>
                            </tr>
                        </table>
                        <div class="mt-2 font-size-lg font-weight-bold"
                             :class="{'text-warning': offer.articles_count === 0}">
                            {{ offer.articles_count }} {{ __('general.articles') }}
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column justify-content-center">
                    <div>
                        <div class="btn-group">
                            <Link as="button"
                                  class="btn btn-outline-secondary btn-hover-primary"
                                  :href="$route('offers.edit', offer.id)"
                            >
                                <i class="fas fa-pen"/>
                                {{ __('actions.edit') }}
                            </Link>
                            <button class="btn btn-outline-secondary btn-hover-danger" @click="deleteOffer"
                                    v-if="!isSystemGenerated">
                                <i class="fas fa-trash"/>
                                {{ __('actions.delete') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!offer.expired"
             class="card-footer py-4"
             :class="{
                'bg-light-danger text-danger': offer.expired,
                'bg-light-light text-dark': !offer.expired
            }">
            <table class="w-100">
                <tr class="row" v-for="store in offer.stores">
                    <td class="font-weight-bold w-25">
                        {{ store.attributes.name.substring(0, 28) }}
                    </td>
                    <td class="w-25">
                        {{ store.attributes.address.street1 }}
                    </td>
                    <td class="w-25">
                        {{ store.attributes.address.city }}
                    </td>
                    <td class="text-right w-25">
                        <Link as="button"
                              :href="$route('offers.widgets.embed', [offer.id, store.id])"
                              class="btn btn-xs btn-link text-hover-primary"
                              :class="{'text-danger cursor-not-allowed': offer.expired, 'text-dark': !offer.expired}"
                              :disabled="offer.expired">
                            <i class="fas fa-code"/>
                            {{ __('actions.embed') }}
                        </Link>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import { Link } from '@inertiajs/vue2';

export default {
    components: {
        Link
    },

    props: {
        offer: Object,
        stores: Array,
    },

    methods: {
        deleteOffer() {
            Swal.fire({
                title: __('actions.remove_thing', {thing: __('general.offer') + ` "${this.offer.name}"`}) + `?`,
                html: __('offers.pre_delete_info'),
                confirmButtonText: __('actions.remove'),
                cancelButtonText: __('actions.abort'),
                showCancelButton: true,
                customClass: {
                    confirmButton: "btn btn-danger m-0",
                },
            }).then((result) => {
                if (result.value) {
                    this.$inertia.delete(this.$route('offers.delete', this.offer.id), {
                        onSuccess: () => {
                            this.$emit('deleted', this.offer.id)
                        }
                    });
                }
            })
        }
    },

    computed: {
        isSystemGenerated() {
            return this.offer.created_by === 'system'
        }
    },
}
</script>

<style scoped>
.row:hover td {
    background-color: rgba(0, 0, 0, 0.05);
}
</style>
